module.exports = __webpack_public_path__ + "media/src/images/list2-39a7bba4aabdb0fbfb34c417bd7e1202.gif";